import { WAVE_APP_ID } from "@vida/wave-core";
import { getIdToken } from "../auth";
import { getAdminApiBaseUrl } from "./waveAccountAPI";

const urlCache = new Map<string, { url: string; expiresAt: number }>();

export async function resolveWaveAgentIconUrl(
  iconS3Key?: string | null,
): Promise<string | null> {
  const key = iconS3Key?.trim();
  if (!key) return null;

  const cached = urlCache.get(key);
  if (cached && cached.expiresAt > Date.now() + 60_000) {
    return cached.url;
  }

  const base = getAdminApiBaseUrl();
  if (!base) return null;

  try {
    const token = await getIdToken();
    const q = new URLSearchParams({ s3Key: key });
    const res = await fetch(`${base}/api/ocean/agent-icon/url?${q.toString()}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "X-Vida-AppId": WAVE_APP_ID,
      },
    });
    if (!res.ok) return null;
    const body = (await res.json()) as { url?: string; publicUrl?: string; expiresIn?: number };
    const url = body.publicUrl?.trim() || body.url?.trim() || null;
    if (!url) return null;
    const ttlMs = Math.max(60, Number(body.expiresIn) || 3600) * 1000;
    urlCache.set(key, { url, expiresAt: Date.now() + ttlMs });
    return url;
  } catch {
    return null;
  }
}
